import { createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';

// TanStack Router instance — file-based routes generated by @tanstack/router-plugin
// routeTree.gen.ts is auto-generated by the Vite plugin on `pnpm dev` / `pnpm build`
export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
});

// Register router for type-safety across the app
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
